import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import knightSprite from "../assets/knight.png";
import princessSprite from "../assets/princess.png";
import sprocketSprite from "../assets/sprocket.png";
import muphySprite from "../assets/muphy.png";
import ruffusSprite from "../assets/ruffus.png";
import meowthaSpriteImg from "../assets/meowtha.png";
import mrSprite from "../assets/mr.png";
import mrsSprite from "../assets/mrs.png";

const SPRITE_MAP = {
  "/assets/knight.png":   knightSprite,
  "/assets/princess.png": princessSprite,
  "/assets/sprocket.png": sprocketSprite,
  "/assets/muphy.png":    muphySprite,
  "/assets/ruffus.png":   ruffusSprite,
  "/assets/meowtha.png":  meowthaSpriteImg,
  "/assets/mr.png":       mrSprite,
  "/assets/mrs.png":      mrsSprite,
};

export default function SidekickBanner() {
  const { userProfile } = useAuth();
  const theme = useTheme();

  // Pick a random message once when the component first appears.
  // useState with a function argument only runs that function once —
  // on the very first render. After that the message stays fixed
  // until the page is reloaded.
  const [message, setMessage] = useState("");

  useEffect(() => {
    const messages = theme.sidekickMessages;
    const randomIndex = Math.floor(Math.random() * messages.length);
    setMessage(messages[randomIndex]);
  }, [theme.id]);

  return (
    <div style={styles.banner(theme)}>
      <img
        src={SPRITE_MAP[theme.sidekickSprite]}
        alt={theme.sidekickName}
        style={styles.sprite}
      />
      <div style={styles.textBlock}>
        <p style={styles.heroName(theme)}>{theme.icon} {theme.sidekickName} says...</p>
        <p style={styles.message(theme)}>{message}</p>
      </div>
    </div>
  );
}

const styles = {
  banner: (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 16,
    backgroundColor: "#ffffff",
    border: `3px solid ${theme.colorPrimary}`,
    borderRadius: 16,
    padding: "12px 20px",
    marginBottom: 24,
  }),
  sprite: {
    width: 72,
    height: 72,
    objectFit: "contain",
    imageRendering: "pixelated",
  },
  textBlock: {
    flex: 1,
  },
  heroName: (theme) => ({
    fontSize: 13,
    color: theme.colorPrimary,
    fontFamily: theme.fontDisplay,
    margin: "0 0 6px 0",
    lineHeight: 1.6,
  }),
  message: (theme) => ({
    fontSize: 15,
    color: "#2d3748",
    fontFamily: theme.fontBody,
    fontWeight: "bold",
    margin: 0,
    lineHeight: 1.5,
  }),
};